<template>
  <a
    :href="link"
    :target="target"
    class="button"
    :class="[
      `button--${size}`,
      `button--${color}`,
      isDisabled && 'button--disabled',
    ]"
  >
    <Icon v-if="icon && icon.length" class="button__icon" :name="icon" />

    <slot />
  </a>
</template>

<script lang="ts">
// Components
import Icon from '@/components/ds/Icon.vue';

export default {
  name: 'ButtonAction',

  components: {
    Icon,
  },

  props: {
    size: {
      type: String,
      required: false,
      default: 'sulguni',
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    color: {
      type: String,
      required: false,
      default: 'rocky',
    },
    link: {
      type: String,
      required: false,
      default: '#',
    },
    target: {
      type: String,
      required: false,
      default: '_blank',
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~/src/assets/stylus/main.styl";

$name = '.button'

{$name}
  @extend $button
  display inline-flex
  transition background $effects.duration

  &--disabled
    @extend $button--disabled

  &--sulguni
    $text("sulguni")

  &--briscola
    $text("briscola")

  &__icon
    margin-right 6px

.button--rocky
  color $colors.rocky
  color var(--rocky)

  &:hover
    color $colors.rockyHover
    color var(--rockyHover)

  &:active
    color $colors.rockyPressed
    color var(--rockyPressed)
</style>
